(() => {
  const JACKET_HANDLES = new Set(['leather-jacket-1', 'the-jacket-red']);
  const LETTERS = /^\p{L}{1,3}$/u;

  function isJacketPage() {
    const product = document.querySelector('[data-product-handle]');
    return product && JACKET_HANDLES.has(product.dataset.productHandle);
  }

  function setError(input, message) {
    const wrap = input.closest('.oom-monogram-field');
    const error = wrap && wrap.querySelector('[data-oom-monogram-error]');
    input.setCustomValidity(message || '');
    input.classList.toggle('oom-monogram-field__input--error', Boolean(message));
    input.setAttribute('aria-invalid', message ? 'true' : 'false');
    if (error) {
      error.textContent = message || '';
      error.hidden = !message;
    }
  }

  function validate(input, live = false) {
    const raw = input.value;
    const upper = raw.toLocaleUpperCase('hu-HU');
    if (upper !== raw) input.value = upper;

    if (!input.value) {
      const message = live ? '' : 'Add meg a monogramod.';
      setError(input, message);
      return false;
    }
    if (input.value.length > 3) {
      setError(input, 'A monogram maximum 3 betű lehet.');
      return false;
    }
    if (!LETTERS.test(input.value)) {
      setError(input, 'Csak betűket használhatsz – szám és speciális karakter nem engedélyezett.');
      return false;
    }
    setError(input, '');
    return true;
  }

  function addField(form) {
    if (form.querySelector('[data-oom-monogram]')) return;
    const submitGroup = form.querySelector('.product-form__controls-group--submit');
    if (!submitGroup) return;

    const uid = Math.random().toString(36).slice(2);
    const wrap = document.createElement('div');
    wrap.className = 'oom-monogram-field';
    wrap.dataset.oomMonogram = '';
    wrap.innerHTML = `
      <label class="oom-monogram-field__label" for="oom-monogram-${uid}">MONOGRAM:</label>
      <input class="input oom-monogram-field__input" id="oom-monogram-${uid}" type="text" name="properties[Monogram]" maxlength="3" required autocomplete="off" autocapitalize="characters" spellcheck="false" inputmode="text" placeholder="PL. ABR" aria-describedby="oom-monogram-help-${uid} oom-monogram-error-${uid}" aria-invalid="false">
      <div class="oom-monogram-field__help" id="oom-monogram-help-${uid}">Maximum 3 betű</div>
      <div class="oom-monogram-field__error" id="oom-monogram-error-${uid}" data-oom-monogram-error role="alert" aria-live="polite" hidden></div>`;
    submitGroup.parentNode.insertBefore(wrap, submitGroup);

    const input = wrap.querySelector('input');
    input.addEventListener('input', () => validate(input, true));
    input.addEventListener('blur', () => validate(input, false));

    form.addEventListener('submit', (event) => {
      if (!validate(input, false)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        input.focus();
      }
    }, true);

    const payment = form.querySelector('.shopify-payment-button');
    if (payment) {
      payment.addEventListener('click', (event) => {
        if (!validate(input, false)) {
          event.preventDefault();
          event.stopImmediatePropagation();
          input.focus();
        }
      }, true);
    }
  }

  function init() {
    if (!isJacketPage()) return;
    document.querySelectorAll('form[action*="/cart/add"]').forEach(addField);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  new MutationObserver(init).observe(document.documentElement, { childList: true, subtree: true });
})();